const Button = (props: any) => <button {...props}>{props.children}</button>;

export default Button;
